import { Injectable, inject } from '@angular/core';
import moment = require('moment-timezone/moment-timezone-utils');
import { FiTimeZonesService } from '@fi-shared/fi-shared-services/fi-time-zones.service';
import { isDefined } from '../utils';

export interface ITimerGradientColor {
    type: TimerGradientColorType;
    lightColor: string;
    darkColor: string;
}
export enum TimerGradientColorType {
    Normal,
    Warning,
    RunningOut,
}

@Injectable()
export class FiGradientTimerService {
    private readonly fiTimeZonesService = inject(FiTimeZonesService);

    public readonly maxAvailableDelay: number = 2147483647; // maximum value of 32-bit signed integer;
    public readonly timerGradientColors: ITimerGradientColor[] = [
        {
            type: TimerGradientColorType.Normal,
            lightColor: '#2196F3',
            darkColor: '#2196F3',
        },
        {
            type: TimerGradientColorType.Warning,
            lightColor: '#FFDCC4',
            darkColor: '#FF8E1C',
        },
        {
            type: TimerGradientColorType.RunningOut,
            lightColor: '#FF897D',
            darkColor: '#DE3730',
        },
    ];

    public formatRemainingTime(remainingTimeMs: number, displayAfterTimeIsOut: boolean): string | undefined {
        if (remainingTimeMs <= 0) {
            return displayAfterTimeIsOut ? '00:00' : undefined;
        }
        // Round down to nearest second to avoid skipping seconds due to millisecond precision
        const remainingSeconds = Math.floor(remainingTimeMs / 1000) * 1000;
        return moment.utc(remainingSeconds).format('mm:ss');
    }

    public getDateTimezoneTimestamp(dateString: string | undefined, timeZone: string | undefined): number {
        const dateTimestamp: number = isDefined(dateString) ? new Date(dateString).getTime() : new Date().getTime();
        if (!timeZone) {
            return dateTimestamp;
        }
        return new Date(this.fiTimeZonesService.localDateToTimeZone(dateTimestamp, timeZone)).getTime();
    }

    public getTotalRemainingTimeMS(
        dueDateTime: string | undefined,
        dueDateTimeZone: string | undefined,
        remainingTimeDelayMS: number | undefined,
    ): number {
        if (!isDefined(dueDateTime) || !isDefined(dueDateTimeZone) || !isDefined(remainingTimeDelayMS)) {
            return 0;
        }

        const usersLocalTimeToAreaTimeZoneMS: number = this.getDateTimezoneTimestamp(undefined, dueDateTimeZone);
        const dueDateTimeMS: number = this.getDateTimezoneTimestamp(dueDateTime, dueDateTimeZone);
        return dueDateTimeMS - usersLocalTimeToAreaTimeZoneMS + remainingTimeDelayMS;
    }
}
